import { Grid } from '@chakra-ui/react';

import { SkeletonCard } from './SkeletonCard';

export const LoadingState = ({ times }: { times: number }) => (
  <Grid templateColumns="repeat(auto-fit, minmax(300px, 1fr))" gap={4}>
    {[...Array(times)].map((_, i) => (
      <SkeletonCard key={i} />
    ))}
  </Grid>
);
